/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useProductItemEvent,
  useViewItemList,
} from '@mercadoni/sinister/dist/cjs/monitors'
import { getProductListInfo } from '@mercadoni/sinister/dist/cjs/productv2'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { useCallback } from 'react'
import { ProductPayload, SendEventSelectProduct } from '~types/index'

interface UseAnalyticsFunctions {
  buildListInfo: ({ category }: ProductPayload) => any
  sendEventViewCategory: ({ category }: ProductPayload) => void
  sendEventSelectProduct: SendEventSelectProduct
}

const useAnalytics = (): UseAnalyticsFunctions => {
  const { headerData } = useHeaderDataContext()
  const { sendViewItemListEvent } = useViewItemList()
  const { sendSelectProductEvent } = useProductItemEvent()

  const buildListInfo = ({ category }: ProductPayload) => ({
    screen_name: headerData?.screenName,
    ...getProductListInfo('home', category?.name, category?.reference),
  })

  const sendEventViewCategory = useCallback(
    ({ category }: ProductPayload) => {
      return sendViewItemListEvent({
        type: 'home',
        category,
        customParams: {
          screen_name: headerData?.screenName,
          url: window.location.href,
        },
        pagination: {
          page: 1,
          pageSize: category?.products?.length,
        },
      })
    },
    [headerData, sendViewItemListEvent]
  )

  const sendEventSelectProduct: SendEventSelectProduct = useCallback(
    ({ category, product }) =>
      sendSelectProductEvent({
        trackSource: 'home',
        category,
        product,
      }),
    [sendSelectProductEvent]
  )

  return { buildListInfo, sendEventViewCategory, sendEventSelectProduct }
}

export default useAnalytics
